import API from '../utils/request'

export function getDetailTemplate (templateUid) {
  return API.get('/management/template/getDetailTemplate', templateUid || undefined)
}
export function saveTemplate (data) {
  return API.post('/management/template/saveTemplate', data)
}
export function getPreviewHtml (data) {
  return API.bolbPost('/management/location/getHtmlPreview', data)
}
export function getTemplateDto () {
  return API.get('/management/template/getTemplateDto')
}
export function deleteTemplate (uid) {
  return API.get('/management/template/deleteTemplate', uid)
}
export function uploadExcel (data) {
  return API.post('/management/template/uploadExcel', data)
}
export function getCoveredCustomerDto (data) {
  return API.post('/management/customerTag/getCoveredCustomerDto', data)
}
export function deleteTargetLocationMapping (targetLocationMappingUid) {
  return API.get('/management/location/deleteTargetLocationMapping', { targetLocationMappingUid: targetLocationMappingUid })
}
export function checkDomain (data) {
  return API.get('/management/location/checkDomain', data)
}
export function uploadImg (data) {
  return API.post('/management/upYun/uploadImg', data)
}
export function uploadNoDeleteImg (data) {
  return API.post('/management/upYun/uploadNoDeleteImg', data)
}
export function deleteTargetLocationMappingByTemplateUidAndLocationGroupUid (data) {
  return API.get('/management/location/deleteTargetLocationMappingByTemplateUidAndLocationGroupUid', data)
}
export function renameTemplate (data) {
  return API.postQuery('/management/template/renameTemplate', data)
}
